import { ISbAlternateObject } from 'storyblok-js-client';

import { getAll } from './getAll';

export const getFolderSlugs = async (folder: string) => {
  try {
    const folderLinks = await getAll<Array<ISbAlternateObject>>(
      'cdn/links',
      {
        version: 'published',
        starts_with: folder,
      },
      { revalidate: 604800 }
    );

    return folderLinks.reduce<Array<string>>((acc, item) => {
      const { is_folder, slug } = item;

      if (is_folder) {
        return acc;
      }

      const processedSlug = slug.replace(`${folder}/`, '');

      if (!processedSlug) {
        return acc;
      }

      return [...acc, processedSlug];
    }, []);
  } catch (error) {
    console.error(`Error getting folder slugs for ${folder}:`, error);
    throw error;
  }
};
